import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { useI18n } from "@/i18n";
import { PageHero } from "@/pages/PageHero";
import { img } from "@/lib/gallery";

const Points = ({ items, prefix }) => (
  <ul className="mt-6 space-y-4">
    {items.map((item, index) => <li key={item} className="flex gap-3 text-[var(--steel)]" data-testid={`${prefix}-point-${index + 1}`}><Check className="mt-0.5 h-5 w-5 shrink-0 text-[var(--gold)]" />{item}</li>)}
  </ul>
);

export default function Resellers() {
  const { t } = useI18n();
  const r = t.resellers;
  return (
    <div data-testid="resellers-page">
      <PageHero eyebrow="MB300 · by NELVIS FRANCE" title={r.title} text={r.intro} image={img(5)} />
      <section className="container-x pb-28">
        <div className="grid gap-14 border-y border-white/12 py-14 lg:grid-cols-12">
          <div className="lg:col-span-5" data-testid="reseller-commission">
            <p className="font-display text-8xl font-black text-[var(--gold)]">5 %</p>
            <h2 className="font-display mt-4 text-3xl font-bold uppercase">{r.commissionTitle}</h2>
            <p className="mt-4 leading-relaxed text-[var(--steel)]">{r.commissionText}</p>
          </div>
          <div className="lg:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--gold)]">{r.partnerKicker}</p>
            <h2 className="font-display mt-4 text-4xl font-bold uppercase">{r.partnerTitle}</h2>
            <Points items={r.partnerPoints} prefix="reseller-partner" />
          </div>
        </div>
        <div className="grid gap-14 py-20 lg:grid-cols-12" data-testid="exclusive-distributor-terms">
          <div className="lg:col-span-5">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--gold)]">{r.exclusiveKicker}</p>
            <h2 className="font-display mt-4 text-5xl font-black uppercase">{r.exclusiveTitle}</h2>
          </div>
          <div className="lg:col-span-7">
            <Points items={r.exclusivePoints} prefix="exclusive-distributor" />
            <p className="mt-8 border-l-2 border-[var(--gold)] pl-5 text-sm leading-relaxed text-white" data-testid="reseller-contract-note">{r.contractNote}</p>
          </div>
        </div>
        <div className="bg-[var(--navy)] px-7 py-12 text-center sm:px-12" data-testid="reseller-cta">
          <h2 className="font-display text-4xl font-black uppercase sm:text-5xl">{r.ctaTitle}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-[var(--steel)]">{r.ctaText}</p>
          <Link to="/contact?subject=reseller" data-testid="reseller-contact-button" className="mt-8 inline-flex items-center gap-2 bg-[var(--gold)] px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-[var(--night)]">{r.cta}<ArrowUpRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}